import { useMemo } from "react";
import { useFilterSettingsStore, useLeaseCompStore, useSaleCompStore } from "..";
import ILocation from "../interfaces/ILocation";
import useLeaseCompsWithFocusArea from "./useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "./useLeaseCompsWithGlobalFilters";
import useSaleCompsWithFocusArea from "./useSaleCompsWithFocusArea";
import useSaleCompsWithGlobalFilters from "./useSaleCompsWithGlobalFilters";

export default function (locations: ILocation[]): ILocation[] {
    const filterSettingsStore = useFilterSettingsStore();
    const saleCompStore = useSaleCompStore();
    const leaseCompStore = useLeaseCompStore();
    const { hideDuplicateLocations } = filterSettingsStore.filters.companySettings;
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(saleCompStore.saleComps));
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(leaseCompStore.leaseComps));

    const makeSetKey = (pipedriveEntityId: any, regridId: any): string => { return `${pipedriveEntityId}|${regridId}` }
    const saleCompsDupKeys = useMemo(() => new Set(saleComps.map(sc => makeSetKey(sc.pipedriveBuyerId, sc.regridId))), [saleComps]);
    const leaseCompsDupKeys = useMemo(() => new Set(leaseComps.map(lc => makeSetKey(lc.pipedriveCompanyId, lc.regridId))), [leaseComps]);

    return useMemo(() => {
        if (!hideDuplicateLocations) return locations;

        return locations.filter((l) => {
            const key = makeSetKey(l.pipedriveCompanyId, l.regridId);
            return !(saleCompsDupKeys.has(key) || leaseCompsDupKeys.has(key));
        });
    }, [locations, hideDuplicateLocations, saleCompsDupKeys, leaseCompsDupKeys]);
}
